// Standalone, zod-free home for InfoModalVersion. Lives apart from ./team so
// that value-importing this enum (e.g. from the checkout UI extension bundle)
// does not drag in the ~3000-line, zod-heavy ./team module. ./team re-exports
// it for existing `@redotech/redo-model/team` importers.

export enum InfoModalVersion {
  V1 = "v1",
  V2 = "v2",
}
